/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThirdPartyNetwork } from '../../models/third-party-network';

export interface ApiMasterThirdPartyNetworkGetActiveGet$Params {
}

export function apiMasterThirdPartyNetworkGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterThirdPartyNetworkGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ThirdPartyNetwork>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterThirdPartyNetworkGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ThirdPartyNetwork>>;
    })
  );
}

apiMasterThirdPartyNetworkGetActiveGet.PATH = '/api/Master/ThirdPartyNetwork/GetActive';
